import { Button, Typography } from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import { IButtonProps } from "../Components";
import { forwardRef } from "react";

const PrimaryButton = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ onClick, title, viewStyle, rightIcon, size = "medium" }, ref) => {
    return (
      <Button
        variant="contained"
        onClick={onClick}
        size={size}
        sx={{ ...styles.button, ...viewStyle }}
        endIcon={rightIcon ? rightIcon : null}
      >
        <Typography sx={{ ...styles.buttonTextStyle }}>{title}</Typography>
      </Button>
    );
  }
);
PrimaryButton.displayName = "PrimaryButton";
export default PrimaryButton;
const styles = {
  button: {
    width: "fit-content",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "1em",
    px: 2,
    py: 1,
    boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.25)",
  },
  buttonTextStyle: {
    fontSize: responsiveFontSize(16),
    fontWeight: 400,
    color: theme.palette.custom?.white || theme.palette.background.default,
    textTransform: "none",
  },
};
